














import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Action } from 'vuex-class'

import UserInterface5AreYouSure from '../../basic-type-4-user-interface/user-interface-5-are-you-sure.vue'


const namespace = 'digitalCurrency'

@Component({
  components: {
    UserInterface5AreYouSure
  }
})
class DigitalCurrencyTransaction8DeleteTransactionButton extends Vue {

  @Prop({ default: '' }) transactionId?: string
  @Prop({ default: () => { return () => 0 } }) navigateBackAfterDelete?: any

  @Action('deleteDigitalCurrencyTransaction', { namespace }) deleteDigitalCurrencyTransaction?: any

  isVisibleDialog: boolean = false
  areYouSureMessage: string = ''
  areYouSureDialogIconId = 'delete'
  areYouSureDialogTitle = 'Delete Transaction'
  areYouSureDialogMessage = `Are you sure you wish to delete this transaction?`
  areYouSureDialogHeaderCssClass = 'error'

  async areYouSureDialogYesOptionEvaluationFunction () {
    await this.deleteDigitalCurrencyTransaction(this.transactionId)

    if (this.navigateBackAfterDelete && typeof this.navigateBackAfterDelete === 'function') {
      this.navigateBackAfterDelete()
    }
    this.isVisibleDialog = false
  }
}

export default DigitalCurrencyTransaction8DeleteTransactionButton

